import { CircularProgress, Backdrop } from "@mui/material";

const SpinnerPageLoader = () => {

    return (
        <Backdrop
            sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: "rgba(0, 0, 0, 0.5)" // Semi-transparent background
            }}
            open={true}
        >
            <CircularProgress size={60} color="inherit" />
        </Backdrop>



    );
}

export default SpinnerPageLoader;